import { WorkshopOrDevelopmentProgrammCreatedEvent } from "./WorkshopOrDevelopmentProgrammCreatedEvent";

export const WorkshopCreatedEvent = ({ event }) => {
  return <WorkshopOrDevelopmentProgrammCreatedEvent event={event} />;
};
